<template>
    <Row>
      <Col :xs="24" :sm="24" :md="24" :lg="4">
        <img src="./logo.png" alt="" class="logo" @click="$router.push('/')" style="cursor:pointer">
      </Col>
      <Col :xs="24" :sm="24" :md="24" :lg="20">
        <div class="manage">| 系统建模与仿真技术
          <span class="phone" style="padding-left:10px;">QQ: 398342328</span>
          <span class="phone">Tel: 15210550848</span>
        </div>
        
      </Col>
    </Row>
</template>

<script>
export default {
  name: 'Head'
}
</script>

<style scoped>
  .ivu-row {
    width: 100%;
    margin: 0 auto;
  }
  .logo {
    margin: 10px 10px 10px 30px;
  }
  @media screen and (max-width:3840px) {
    .ivu-row {
      width: 1200px;
    }
    .manage {
      font-size: 23px;
      color: #006CFF;
      padding: 0px 20px 10px 0px;
      margin: 20px 0px 0px 0px;
    }
    .phone {
      float: right;
      font-size: 18px;
      color: #666666;
      line-height: 40px;
    }
  }
  @media screen and (max-width:1200px) {
    .ivu-row {
      width: 996px;
    }
    .manage {
      font-size: 23px;
      color: #006CFF;
      height: 50px;
      padding: 0px 20px 10px 0px;
      margin: 20px 0px 0px 0px;
    }
    .logo {
      margin: 10px 10px 10px 10px;
    }
  }
  @media screen and (max-width:996px) {
    .ivu-row {
      width: 768px;
    }
    .manage {
      font-size: 23px;
      color: #006CFF;
      height: 50px;
      float: right;
      padding: 0px 20px 10px 0px;
      margin: 20px 170px 0px 0px;
    }
  }
  @media screen and (max-width:768px) {
    .ivu-row {
      width: 100%;
    }
    .manage {
      font-size: 1.25rem;
      color: #006CFF;
      float: left;
      padding: 0px 20px 10px 0px;
      margin: 0px 0px 0px 20px;
    }
  }
</style>
